<template>
  <div class="page-wrapper">
    <div class="user-info">
      <div class="left-box">
        <van-image width="60px" height="60px" round fit="cover" :src="avatar" />
        <div class="btn" @click="unbundle">{{is365 ? '更换绑定': '退出登录'}}</div>
      </div>
      <div class="right-box">
        <div class="row">
          <span class="left">{{realName}}</span>
          <div class="right" v-if="isSwitchAccount" @click="changeRole">
            <img src="@/assets/icons/icon_qh@2x.png" alt="" />
            <span class="btn">切换账号</span>
          </div>
        </div>
        <div class="right-bottom">
          <div class="row" v-if="userInfo.staffPosition">拓客宝身份：{{userInfo.roleName}}</div>
          <div class="row" v-if="userInfo.storeName">主要岗位：{{userInfo.staffPosition}}</div>
          <div class="row " v-if="userInfo.saleShopName">所属门店：{{userInfo.saleShopName}}</div>
        </div>
      </div>
    </div>
    <div class="menu-list one">
      <van-cell-group inset>
        <van-cell class="refund" 
          title="退款待处理订单" 
          :value="personalData.waitRefundNum" 
          is-link 
          @click="to('/customer-list',5)"
        >
          <div slot="icon" class="icon-box">退<span class="rmb">¥</span></div>
        </van-cell>
      </van-cell-group>
    </div>
    
    <div class="menu-list">
      <van-cell-group inset>
        <van-cell title="活动数据" value="" is-link @click="to('/activity-data')">
          <div slot="icon">
            <van-image width="20px" height="20px" fit="container" class="menu-icon" :src="activityIcon" />
          </div>
        </van-cell>
        <van-cell title="客户列表" value="" is-link @click="to('/customer-list')">
          <div slot="icon">
            <van-image width="20px" height="20px" fit="container" class="menu-icon" :src="clientIcon" />
          </div>
        </van-cell>
        <van-cell title="入网签约" value="" v-if="jjInfo.isJperson" is-link @click="openJj">
          <div slot="icon">
            <van-image width="20px" height="20px" fit="container" class="menu-icon" :src="netInIcon" />
          </div>
        </van-cell>
        <van-cell v-if="isDistributor || isShopowner" title="提现/入网签约设置" value=""  is-link @click="to('/account')">
          <div slot="icon">
            <van-image width="20px" height="20px" fit="container" class="menu-icon" :src="withdrawIcon" />
          </div>
        </van-cell>
        <van-cell v-if="isDistributor" title="中奖线索" value="" is-link @click="to('/winning-clue')">
          <div slot="icon">
            <van-image width="20px" height="20px" fit="container" class="menu-icon" :src="threadIcon" />
          </div>
        </van-cell>
        <van-cell  title="微信钱包提现" value="" v-if="isWithdrawSet" is-link @click="to('/withdrawal-home')">
          <div slot="icon">
            <van-image width="20px" height="20px" fit="container" class="menu-icon" :src="weChatWalletIcon" />
          </div>
        </van-cell>
        <van-cell  
          title="资金对账" value="" is-link @click="to('/capital-checking')"
          v-if="isWithdrawSet || isDistributor || isShopowner"
        >
          <div slot="icon">
            <van-image width="20px" height="20px" fit="container" class="menu-icon" :src="capitalIcon" />
          </div>
        </van-cell>
        <van-cell title="扫一扫" value="" is-link @click="to('/scan')">
          <div slot="icon">
            <van-image width="20px" height="20px" fit="container" class="menu-icon" :src="scanIcon" />
          </div>
        </van-cell>
        <van-cell v-if="isTeacher || isDistributor || isShopowner" title="数据下载" value="" is-link @click="to('/data-download')">
          <div slot="icon">
            <van-image width="20px" height="20px" fit="container" class="menu-icon" :src="dataLownloadIcon" />
          </div>
        </van-cell>
        <van-cell v-if="isTeacher || isDistributor || isShopowner" title="导出列表" value="" is-link @click="to('/export-list')">
          <div slot="icon">
            <van-image width="20px" height="20px" fit="container" class="menu-icon" :src="exporListIcon" />
          </div>
        </van-cell>
        <van-cell v-if="isTeacher || isDistributor || isShopowner" title="草稿箱" value="" is-link @click="to('/drafts')">
          <div slot="icon">
            <van-image width="20px" height="20px" fit="container" class="menu-icon" :src="draftsIcon" />
          </div>
        </van-cell>
      </van-cell-group>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import avatar from '@/assets/icons/avatar.png'
import activityIcon from '@/assets/icons/list_icon_data@2x.png'
import clientIcon from '@/assets/icons/icon-part-in-38px@2x.png' 
import withdrawIcon from '@/assets/icons/list_icon_apply@2x.png' 
import netInIcon from '@/assets/icons/netIn-icon.png'
import threadIcon from '@/assets/icons/list_icon_gift@2x.png'
import weChatWalletIcon from '@/assets/icons/list_icon_money@2x.png'
import capitalIcon from '@/assets/icons/list_icon_tx@2x.png'
import scanIcon from '@/assets/icons/icon-scan-38px@2x.png' 
import dataLownloadIcon from '@/assets/icons/data_download.png'
import exporListIcon from '@/assets/icons/export-list.png'
import draftsIcon from '@/assets/icons/icon-draft-38px@2x.png'

import { mapGetters } from 'vuex'
import { setToken } from '@/utils/auth'
import { domainName } from '@/utils/constant'
export default {
  name: 'my',
  computed: {
    ...mapGetters([
      'isTeacher',
      'isDistributor',
      'isShopowner',
      'isGuide',
      'userInfo',
    ]),
    realName() {
      if (this.userInfo.telephone) {
        return `${this.userInfo.realName}(${this.userInfo.telephone})`
      }else {
        return this.userInfo.realName
      }
    },
    is365() {
      return this.$cache.is365()
    },
  },
  data() {
    return {
      avatar,
      activityIcon,
      clientIcon,
      withdrawIcon,
      netInIcon,
      threadIcon,
      weChatWalletIcon,
      capitalIcon,
      scanIcon,
      dataLownloadIcon,
      exporListIcon,
      draftsIcon,
      isSwitchAccount: false,
      personalData: {},
      isWithdrawSet: false,
      jjInfo: {}
    }
  },
  mounted() {
    this.getActivitySignupData()
    this.refreshLoginUserList()
    this.checkIsWithdrawal()
    this.getFindJJInfo()
  },
  methods: {
    getActivitySignupData() {
      this.$api.h5.getActivitySignupData({})
        .then(res => {
          this.personalData = res.data
        })
    },
    refreshLoginUserList() {
      const telephoneMd5 = this.$cache.getLoginInfo().telephoneMd5
      this.$api.common.getLoginUserList({telephoneMd5})
        .then(res => {
          this.$cache.setLoginUserList(res.data || [])
          if (res.data && res.data.length <= 1) {
           this.btnLogin(res.data[0].id)
          } else {
            this.isSwitchAccount = true
          }
        })
    },
    btnLogin(id) {
      let parmes = {
        userId: id,
        wxToken: this.$cache.getLoginInfo().wxToken,
        flag: this.$cache.is365() ? 2 : 1
      };
      this.$api.common.confirmLoginUser(parmes)
        .then(async _ => {
          // 获取部门
          const res = await this.$api.h5.userSaleShopInfo()
          if (res.data.length > 1) {
            this.isSwitchAccount = true
          }
        })
    },
    to(path,state = null) {
      this.$router.push({
        path: path,
        query: {state}
      })
      
    },
    changeRole() {
      this.$router.push({
        path: '/role-change',  
      })
    },
    unbundle() {
      let title = this.is365 ? '更换绑定': '退出登录'
      this.$dialog.confirm({
        title,
        message: `请问是否${title}？<br />退出后再次使用需重新${this.is365 ? '绑定': '登录'}}`,
      }).then( async _ => {
        if (this.is365) {
         const res = await this.$api.h5.unXcxBinding()
         this.$cache.setWxBinDing(false)
          setToken("")
          this.$router.push({
            path: '/applet-login',
            query: {
              source: 'my',
              xcxLink:res.data
            }
          })
        } else {
          await this.$api.h5.unBinding()
          this.$router.push({
            path: '/binding',  
          })
        }
      
      }).catch(_=> {})
    },
    checkIsWithdrawal() {
      this.$api.withdrawal.checkIsWithdrawal()
        .then(res => {
          this.isWithdrawSet = res.data ? true : false
        })
    },
    getFindJJInfo() {
      this.$api.common.findJJInfo()
        .then(res => {
          if (res.success) {
            this.jjInfo = res.data
            // 是否进件人或是经销商并且未配置进件人
            if (res.data.isJperson || res.data.config === 'false') {
              this.show = true
            }
            this.$store.commit('setJjInfo', res.data)
          }
          
        })
    },
    openJj() {
      const { accesserId="001",accesserUserId ='002',url ='url' } = this.jjInfo
      window.open(`${domainName}?accesser_id=${accesserId}&accesser_user_id=${accesserUserId}&h5UserId=${this.userInfo.id}&url=${url}`)
      // window.open(`http://192.168.78.18:9530?accesserId=${accesserId}&accesserUserId=${accesserUserId}&url=${url}`)
    },
  },
}
</script>

<style lang="stylus" scoped>
.page-wrapper
  min-height calc(100vh - 50px)
  overflow hidden
.user-info {
  display: flex;
  width: 100%;
  height: 140px;
  padding: 16px 0 16px 15px;
  box-sizing: border-box;
  background: linear-gradient( 180deg, #FF8B20 0%, #FF6B59 100%);
  .left-box {
    display flex;
    flex-direction: column;
    align-items: center;
    margin-right: 18px;
    .btn {
      width: 66px;
      height: 20px;
      line-height 20px
      text-align center
      background: rgba(0,0,0,0.15);
      border-radius: 10px;
      color: #fff;
      font-size: 12px;
      margin-top: 5px;
    }
  }
  .right-box {
    color: #FFFFFF;
    flex: 1;
    .row {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 12px;
      margin-top: 4px;
      .left {
        flex: 1;
        font-size: 16px;
        font-weight: bold;
      }
      .right {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 83px;
        height: 27px;
        font-size: 12px;
        padding-left: 4px;
        background: rgba(0,0,0,0.15);
        border-radius: 50px 0px 0px 50px;
        img {
          width: 19px;
          height: 19px;
        }
        .btn {
          margin-right: 6px;
        }
      }
      &:first-child {
        margin-top: 0;
      }
    }
    .right-bottom {
      margin-right: 10px;
    }
  }
}
.menu-list
  margin:  10px 0
  .icon-box {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 25px;
    height: 25px;
    border-radius: 50%;
    margin-right: 5px;
    color: #F23D20;
    font-size: 12px;
    background: #FFEDEA;
    .rmb {
      display: inline-block;
      font-size: 10px;
      margin-top: -4px;
    }
  }
.one {
  margin-top: -24px;
}
.menu-icon
  position relative
  top 2px
  margin-right 10px

.refund > >>>.van-cell__value {
  color: #F23D20;
}


// svg css
.waves {
  position:relative;
  width: 100%;
  margin-bottom:-7px; /*Fix for safari gap*/
}

/* Animation */

.parallax > use {
  animation: move-forever 25s cubic-bezier(.55,.5,.45,.5)     infinite;
}
.parallax > use:nth-child(1) {
  animation-delay: -2s;
  animation-duration: 7s;
}
.parallax > use:nth-child(2) {
  animation-delay: -3s;
  animation-duration: 10s;
}
.parallax > use:nth-child(3) {
  animation-delay: -4s;
  animation-duration: 13s;
}
.parallax > use:nth-child(4) {
  animation-delay: -5s;
  animation-duration: 20s;
}
@keyframes move-forever {
  0% {
  transform: translate3d(-90px,0,0);
  }
  100% { 
    transform: translate3d(68px,0,0);
  }
}
// /*Shrinking for mobile*/
// @media (max-width: 768px) {
//   .waves {
//     height:40px;
//     min-height:40px;
//   }
// }
</style>